Object.defineProperty(exports, '__esModule', { value: true });

var coreComponentsBaseModal = require('../base-modal');

var ModalContext = coreComponentsBaseModal.BaseModalContext;

exports.ModalContext = ModalContext;
